/* Cobra Coldres — Configurador "Monte o seu" (v3).
   Fluxo enxuto: Fabricante → Modelo(multi) → Tipo de Uso → Resultado.
   Barra de progresso animada; cor de destaque por etapa (settings da seção);
   transição deslizante entre etapas; resultado roteia estoque × encomenda.
   Mão/cor/acessório saem do filtro — o cliente escolhe na página do produto.
   Vanilla JS, sem libs. */
(function () {
  'use strict';

  function parseList(str) {
    return (str || '')
      .split(/[\n,]+/)
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      if (k === 'text') node.textContent = attrs[k];
      else if (k === 'html') node.innerHTML = attrs[k];
      else if (attrs[k] != null) node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function readJSON(node) {
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  /* normalização p/ comparar tags, opções e textos (sem acento, só [a-z0-9]) */
  function norm(s) {
    s = (s == null ? '' : String(s)).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s.replace(/[^a-z0-9]+/g, '');
  }
  function opt(variant, i) { return variant['option' + (i + 1)]; }
  /* exibição: inteiro sem "R$" nem centavos (350, 1.350); trunca os centavos.
     O carrinho/checkout mantêm R$ e centavos. (Decisão 2026-06-12.) */
  function fmtPreco(v) {
    var n = Math.floor(Number(v) || 0);
    try {
      return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(n);
    } catch (e) {
      return String(n);
    }
  }

  var DELAY_SELECAO = 350; // ms — o cliente VÊ a seleção antes da etapa avançar

  // Ícone do chat do site (mesmo desenho do snippet chat-icone.liquid).
  var CHAT_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd" aria-hidden="true" focusable="false"><path d="M12 2.5c-5.24 0-9.5 3.79-9.5 8.47 0 2.66 1.37 5.03 3.5 6.6v3.02c0 .6.67.96 1.17.62l2.93-1.95c.61.11 1.25.17 1.9.17 5.24 0 9.5-3.79 9.5-8.46 0-4.68-4.26-8.47-9.5-8.47zM8 12.27a1.3 1.3 0 1 1 0-2.6 1.3 1.3 0 0 1 0 2.6zm4 0a1.3 1.3 0 1 1 0-2.6 1.3 1.3 0 0 1 0 2.6zm4 0a1.3 1.3 0 1 1 0-2.6 1.3 1.3 0 0 1 0 2.6z"/></svg>';

  // Ícone oficial do WhatsApp (mesmo path do snippet whatsapp-comprar.liquid da PDP).
  var WA_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.359.101 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.582 0 11.94-5.359 11.944-11.893a11.821 11.821 0 00-3.42-8.45"/></svg>';

  // Fluxo (2026-07-07): sequência dinâmica de telas. Lanterna e Red Dot só entram
  // nos usos que aceitam acessório (tem_acessorio). Ordem: fabricante → modelo →
  // uso → [lanterna sim/não → marca → modelo] → [red dot] → resultado.
  var ORDEM_TELA = ['fab', 'modelo', 'uso', 'porte', 'lanterna', 'lantMarca', 'lantModelo', 'mao', 'reddot', 'resultado'];
  // 'mao' e 'cor' não são telas do funil (só existem no card sob encomenda), mas entram
  // aqui no fim para serem zerados junto quando o cliente troca algo lá atrás.
  // ⚠️ CAMPOS e TELA_CAMPO andam juntos: o índice de TELA_CAMPO aponta para CAMPOS, e é o
  // que o `limparApos` usa para zerar as respostas à frente. Mexeu num, mexa no outro.
  var CAMPOS = ['fabricante', 'modelos', 'uso', 'porte', 'temLanterna', 'lanternaFab', 'lanterna', 'mao', 'reddot', 'cor'];
  var TELA_CAMPO = { fab: 0, modelo: 1, uso: 2, porte: 3, lanterna: 4, lantMarca: 5, lantModelo: 6, mao: 7, reddot: 8 };

  function Configurador(root) {
    this.root = root;
    this.stage = root.querySelector('[data-cfg-stage]');
    this.barra = root.querySelector('[data-cfg-progress]');
    this.passoEl = root.querySelector('[data-cfg-passo]');   // contador "1/3"
    this.subEl = root.querySelector('[data-cfg-sub]');       // pergunta do passo
    this.trilhaEl = root.querySelector('[data-cfg-trilha]'); // chips das escolhas
    this.overlay = root.querySelector('[data-cfg-overlay]'); // funil em tela cheia
    this.overlayScroll = root.querySelector('[data-cfg-overlay-scroll]');
    this.waNum = root.getAttribute('data-wa-numero') || '';
    this.waMsg = root.getAttribute('data-wa-msg') || '';
    this.canal = root.getAttribute('data-canal') || 'chat';
    this.chatContato = root.getAttribute('data-chat-contato') || '/pages/contato';

    this.fabricantes = Array.prototype.map.call(root.querySelectorAll('.cfg-fab'), readJSON)
      .filter(Boolean)
      .map(function (f) { f.modelos = parseList(f.modelos); f.populares = parseList(f.populares); return f; });
    this.usos = Array.prototype.map.call(root.querySelectorAll('.cfg-uso'), readJSON).filter(Boolean);
    var opts = readJSON(root.querySelector('.cfg-opts')) || {};
    this.L = opts.labels || {};
    // lanternas do setting: "Marca: modelo1, modelo2" por linha (linhas viram ';' no
    // embed). Linha sem ':' = compat com o formato antigo (marca = 1ª palavra).
    var gruposLant = {}, ordemLant = [];
    (opts.lanternas || '').split(/[;\n]+/).forEach(function (linha) {
      linha = linha.trim();
      if (!linha) return;
      var fab, modelos, i = linha.indexOf(':');
      if (i > 0) {
        fab = linha.slice(0, i).trim();
        modelos = parseList(linha.slice(i + 1));
      } else {
        var partes = linha.split(/\s+/);
        fab = partes[0];
        modelos = [partes.slice(1).join(' ') || partes[0]];
      }
      var k = norm(fab);
      if (!k) return;
      if (!gruposLant[k]) { gruposLant[k] = { fab: fab, modelos: [] }; ordemLant.push(gruposLant[k]); }
      modelos.forEach(function (m) {
        if (m && gruposLant[k].modelos.indexOf(m) === -1) gruposLant[k].modelos.push(m);
      });
    });
    this.lanternas = ordemLant; // [{fab, modelos[]}]
    // mão e cor: usadas só no card sob encomenda (com estoque, quem pergunta é a PDP)
    this.maos = parseList(opts.maos);
    this.cores = parseList(opts.cores);

    // liga/desliga geral do passo cintura × perna (Theme editor). Ausente = LIGADO: a
    // regra de negócio é "não fazemos de perna", então o padrão seguro é perguntar.
    this.porteOn = root.getAttribute('data-porte-on') !== 'false';

    this.pix = {
      on: root.getAttribute('data-pix-on') === 'true',
      pct: parseFloat(root.getAttribute('data-pix-pct')) || 0,
      label: root.getAttribute('data-pix-label') || 'no Pix'
    };

    this.state = { tela: 'fab', fabricante: null, modelos: [], uso: null, porte: null,
                   temLanterna: null, lanternaFab: null, lanterna: null, reddot: null,
                   mao: null, cor: null };
    this._prevTela = 'fab';
    this._travado = false; // evita duplo clique durante o delay de seleção

    // deep-link dos cards da home (/?uso=ostensivo): pré-escolhe o tipo de uso e
    // pula o passo 3 — o cliente só escolhe a arma e cai direto no resultado.
    // Casa por rótulo normalizado ("ostensivo" acha "Ostensivo (OWB)").
    this._usoPre = null;
    var mUso = /[?&]uso=([^&#]+)/.exec(window.location.search);
    if (mUso) {
      var alvoUso = norm(decodeURIComponent(mUso[1]));
      if (alvoUso) {
        this._usoPre = this.usos.filter(function (u) {
          return norm(u.rotulo).indexOf(alvoUso) !== -1;
        })[0] || null;
      }
    }
    // &lanterna=1 (card "Com lanterna"): depois do modelo da arma entra o passo
    // "Qual é a sua lanterna?"; o resultado mostra SÓ coldres com lanterna (filtrados
    // pela escolhida) e, sem pronta entrega, cai na encomenda com a lanterna nomeada
    this._lanternaPre = /[?&]lanterna=(1|true)\b/.test(window.location.search);

    // O overlay é position:fixed, mas um ancestral com transform/will-change (ex.: a
    // animação "reveal on scroll" do Dawn) CONFINA o fixed — no desktop ele renderiza
    // embutido e o overflow corta a 2ª coluna. Move o overlay pro <body> (fixo à
    // viewport de verdade); leva a classe de esquema de cor da seção p/ manter o tema.
    // Feito DEPOIS de ler os <script> de dados (que estão dentro do overlay).
    if (this.overlay && this.overlay.parentNode && this.overlay.parentNode !== document.body) {
      var ov = this.overlay;
      root.className.split(/\s+/).forEach(function (c) { if (c.indexOf('color-') === 0) ov.classList.add(c); });
      document.body.appendChild(ov);
    }

    this.render();

    // abrir/fechar o funil em tela cheia (lançador fica no section; ✕ e "Página inicial"
    // ficam DENTRO do overlay, que foi movido pro body — por isso a busca separada)
    var self = this;
    Array.prototype.forEach.call(root.querySelectorAll('[data-cfg-abrir]'), function (b) {
      b.addEventListener('click', function () { self.abrirOverlay(); });
    });
    Array.prototype.forEach.call((this.overlay || root).querySelectorAll('[data-cfg-fechar]'), function (b) {
      b.addEventListener('click', function () { self.fecharOverlay(); });
    });
    // "Voltar" do rodapé fixo: volta uma etapa. Fica sempre visível (menos no 1º passo);
    // o render() liga/desliga conforme a tela. Substitui os "Voltar" que ficavam no fim do
    // palco (invisíveis abaixo das listas longas de modelo).
    this.btnVoltar = (this.overlay || root).querySelector('[data-cfg-voltar]');
    if (this.btnVoltar) {
      this.btnVoltar.addEventListener('click', function () { self.voltar(); });
      this.btnVoltar.hidden = (self.state.tela === 'fab');
    }
    // back do Android e ESC fecham o funil (não trava de verdade)
    window.addEventListener('popstate', function () {
      if (self.overlayAberto()) self.fecharOverlay(true);
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.overlayAberto()) self.fecharOverlay();
    });
    // veio de um card de uso (?uso=): já abre o funil em tela cheia
    if (this._usoPre || /[?&]uso=/.test(window.location.search)) this.abrirOverlay();

    // pré-carrega o índice do catálogo DEPOIS do paint (não trava o LCP)
    var pre = function () { self.ensureIndex(); };
    if ('requestIdleCallback' in window) requestIdleCallback(pre, { timeout: 4000 });
    else setTimeout(pre, 2500);
  }

  /* ---- funil em tela cheia (overlay) ---- */
  Configurador.prototype.overlayAberto = function () {
    return !!(this.overlay && this.overlay.classList.contains('is-open'));
  };
  Configurador.prototype.abrirOverlay = function () {
    if (!this.overlay || this.overlayAberto()) return;
    this.overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (this.overlayScroll) this.overlayScroll.scrollTop = 0;
    // empurra um estado p/ o back do celular fechar (em vez de sair do site)
    try { history.pushState({ cfgOverlay: 1 }, ''); this._pushou = true; } catch (e) {}
  };
  Configurador.prototype.fecharOverlay = function (dePop) {
    if (!this.overlay) return;
    this.overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    // limpa ?uso= p/ um refresh não reabrir o funil
    try {
      if (/[?&]uso=/.test(window.location.search)) history.replaceState(null, '', window.location.pathname);
    } catch (e) {}
    if (!dePop && this._pushou) { this._pushou = false; try { history.back(); } catch (e) {} }
  };

  /* Índice enxuto do catálogo (só produtos publicados; exclui produtos-base) */
  Configurador.prototype.ensureIndex = function () {
    if (this._idx) return this._idx;
    this._idx = fetch('/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        return (j.products || [])
          .filter(function (p) { return (p.tags || []).map(norm).indexOf('sobencomenda') === -1; })
          .map(function (p) {
            var opts = p.options || [];
            var acha = function (re) {
              for (var i = 0; i < opts.length; i++) {
                var nome = typeof opts[i] === 'string' ? opts[i] : (opts[i] && opts[i].name) || '';
                if (re.test(norm(nome))) return i;
              }
              return -1;
            };
            return {
              handle: p.handle,
              titulo: p.title,
              tags: (p.tags || []).map(norm),
              img: (p.images && p.images[0] && p.images[0].src) || null,
              iMao: acha(/^mao$/), iCor: acha(/^cor$/), iRd: acha(/red/),
              variants: p.variants || []
            };
          });
      })
      .catch(function () { return []; });
    return this._idx;
  };

  /* Produto-base sob encomenda (lazy, cacheado por handle) */
  Configurador.prototype.ensureBase = function (handle) {
    this._bases = this._bases || {};
    if (!handle) return Promise.resolve(null);
    if (!this._bases[handle]) {
      this._bases[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); })
        .catch(function () { return null; });
    }
    return this._bases[handle];
  };

  /* pergunta do passo no subtítulo do cabeçalho (estilo app); fallback = h3 no palco */
  Configurador.prototype.setSub = function (txt) {
    if (this.subEl) { this.subEl.textContent = txt || ''; return; }
    if (txt) this.stage.appendChild(el('h3', { 'class': 'cfg-step__title', text: txt }));
  };

  /* ---- máquina de telas (sequência dinâmica) ---- */
  Configurador.prototype.usoEfetivo = function () { return this._usoPre || this.state.uso; };
  Configurador.prototype.usoAceitaAcessorio = function () {
    var u = this.usoEfetivo();
    if (!u) return true; // uso ainda não escolhido: assume que sim (barra não recua)
    return u.acessorio !== false;
  };
  /* Revólver (Cobra 2026-07-08): Taurus com "RT" / Rossi com "RM" ou "RP". Revólver não
     tem trilho de lanterna nem óptica — o funil pula a etapa de lanterna E o modelo some
     da lista quando o cliente entrou pelo card "Com lanterna". */
  function revModelo(fab, modelo) {
    var f = norm(fab || ''), mm = norm(modelo || '');
    if (f.indexOf('taurus') !== -1 && /rt\d/.test(mm)) return true;
    if (f.indexOf('rossi') !== -1 && /r[mp]\d/.test(mm)) return true;
    return false;
  }
  Configurador.prototype.ehRevolver = function () {
    var fab = this.state.fabricante;
    return (this.state.modelos || []).some(function (m) { return revModelo(fab, m); });
  };
  // modelos do fabricante, TIRANDO revólveres quando o fluxo é "com lanterna"
  Configurador.prototype.modelosDoFab = function (fab) {
    var ms = (fab && fab.modelos) ? fab.modelos : [];
    if (!this._lanternaPre) return ms;
    var nome = fab ? fab.nome : '';
    return ms.filter(function (m) { return !revModelo(nome, m); });
  };
  Configurador.prototype.temLanternaEfetivo = function () {
    if (this.ehRevolver()) return false; // revólver nunca entra no fluxo de lanterna
    return this._lanternaPre || this.state.temLanterna === true;
  };

  /* Cintura × perna (Cobra, 2026-08-21): NÃO fabricamos mais coldre ostensivo de perna
     nem com tira de perna. O funil precisa perguntar antes de seguir, senão o cliente
     monta a configuração inteira esperando algo que não existe.

     Quem decide: o rótulo do uso ("Ostensivo (OWB)", "Mini ostensivo") — e não a tag de
     estoque, que pode ser sobrescrita por bloco. Cada bloco de uso pode forçar
     sim/não pelo editor de tema (`pergunta_perna`), e a seção tem liga/desliga geral. */
  Configurador.prototype.perguntaPorte = function () {
    if (!this.porteOn) return false;
    var u = this.usoEfetivo();
    if (!u) return false;
    var forcado = norm(u.perguntaPerna || 'auto');
    if (forcado === 'sim') return true;
    if (forcado === 'nao') return false;
    return norm(u.rotulo || '').indexOf('ostensiv') !== -1;   // auto
  };

  /* Red dot só existe onde cabe óptica: uso que aceita acessório e arma que não é
     revólver — mesma regra da PDP, que esconde o segmentado de Red Dot no revólver. */
  Configurador.prototype.aceitaRedDot = function () {
    return this.usoAceitaAcessorio() && !this.ehRevolver();
  };

  /* telas que compõem o funil AGORA, conforme o estado (uso/acessório/lanterna) */
  Configurador.prototype.sequencia = function () {
    var s = this.state, seq = ['fab', 'modelo'];
    if (!this._usoPre) seq.push('uso');
    // Cintura × perna: só no ostensivo. Entra MESMO com `_usoPre` (o card da home
    // /?uso=ostensivo pula a escolha do uso, mas a expectativa de coldre de perna
    // continua existindo — é justamente o cliente que já sabe que quer ostensivo).
    if (this.perguntaPorte()) seq.push('porte');
    if (this.usoAceitaAcessorio() && !this.ehRevolver()) {
      if (!this._lanternaPre) seq.push('lanterna');            // pergunta sim/não
      if (this.temLanternaEfetivo()) { seq.push('lantMarca'); seq.push('lantModelo'); }
      // Red dot NÃO é perguntado no funil (2026-07-07): COM estoque o cliente escolhe na
      // PDP (seletor + popup de confirmação) e o resultado cai na variante sem red dot.
      // SOB ENCOMENDA não existe PDP — lá a pergunta aparece dentro do card do resultado
      // (opcoesEncomenda), senão a encomenda chega ao atendimento sem o dado que muda o
      // recorte do coldre. (2026-08-19)
    }
    // MAO (Cobra, 2026-08-26): passou a ser passo do funil, logo DEPOIS da lanterna.
    // Deixou de ser detalhe de pedido e virou ROTA: canhoto sem percurso de corte no CNC
    // nao e pronta entrega, e o resultado precisa saber disso antes de prometer envio.
    // Fora do fluxo com lanterna ela cai no fim, que continua sendo "depois da lanterna".
    seq.push('mao');
    seq.push('resultado');
    return seq;
  };

  /* limpa as respostas das telas À FRENTE de `tela` (mantém a dela) */
  Configurador.prototype.limparApos = function (tela) {
    var k = TELA_CAMPO[tela];
    if (k == null) return;
    for (var i = k + 1; i < CAMPOS.length; i++) {
      this.state[CAMPOS[i]] = (CAMPOS[i] === 'modelos') ? [] : null;
    }
  };

  /* progresso: contador X/N + barra + trilha de chips (chip volta à tela) */
  Configurador.prototype.setProgress = function () {
    var self = this, seq = this.sequencia();
    var idx = seq.indexOf(this.state.tela); if (idx < 0) idx = 0;
    this.root.setAttribute('data-cfg-fase', String(Math.min(idx + 1, 4)));
    var totalPassos = seq.length - 1; // exclui 'resultado' da contagem
    if (this.passoEl) {
      this.passoEl.innerHTML = '';
      this.passoEl.appendChild(el('b', { text: String(Math.min(idx + 1, totalPassos)) }));
      this.passoEl.appendChild(document.createTextNode('/' + totalPassos));
    }
    if (this.barra) {
      var fill = this.barra.querySelector('.cfg-progress__fill');
      if (fill) fill.style.width = Math.max(8, Math.round((idx / (seq.length - 1)) * 100)) + '%';
    }
    if (this.trilhaEl) {
      this.trilhaEl.innerHTML = '';
      this.chipsTrilha().forEach(function (c) {
        var ci = seq.indexOf(c.tela);
        // uso pré-definido por card não está na sequência, mas continua EDITÁVEL:
        // mostra o chip mesmo assim (Velado/Ostensivo) p/ o cliente poder trocar
        var usoPreEditavel = (c.tela === 'uso' && self._usoPre && self.state.uso);
        if (!usoPreEditavel && (ci < 0 || ci >= idx)) return; // só telas já respondidas
        var chip = el('button', { type: 'button', 'class': 'cfg-trilha__chip',
          title: 'Alterar', 'aria-label': 'Alterar: ' + c.label, text: c.label });
        chip.addEventListener('click', function () { self.voltarPara(c.tela); });
        self.trilhaEl.appendChild(chip);
      });
    }
  };

  /* rótulos dos chips da trilha, na ordem do funil */
  Configurador.prototype.chipsTrilha = function () {
    var s = this.state, out = [];
    if (s.fabricante) out.push({ tela: 'fab', label: s.fabricante });
    if (s.modelos.length) out.push({ tela: 'modelo', label: s.modelos.join(', ') });
    if (s.uso) out.push({ tela: 'uso', label: s.uso.rotulo });
    // só 'cintura' vira chip: 'perna' nunca avança, então nunca fica para trás
    if (s.porte === 'cintura') out.push({ tela: 'porte', label: this.L.porteCintura || 'Na cintura' });
    if (s.lanterna) out.push({ tela: 'lantModelo', label: s.lanterna });
    else if (s.temLanterna === false) out.push({ tela: 'lanterna', label: this.L.semLanterna || 'Sem lanterna' });
    if (s.reddot === true) out.push({ tela: 'reddot', label: this.L.redDotSim || 'Com red dot' });
    else if (s.reddot === false) out.push({ tela: 'reddot', label: this.L.redDotNao || 'Sem red dot' });
    return out;
  };

  Configurador.prototype.waLink = function (msg) {
    if (this.canal === 'chat') return null;   // canal chat: nenhum link de WhatsApp
    if (!this.waNum) return null;
    return 'https://wa.me/' + this.waNum + '?text=' + encodeURIComponent(msg || this.waMsg);
  };

  /* Atributos do <a> de atendimento, no canal vigente.
     - chat: link real para a página de contato + data-abrir-chat (o cobra-chat.js
       intercepta e abre o widget; se o chat cair, o link continua valendo).
     - whatsapp: o wa.me de sempre.
     Devolve null quando não há canal configurado — aí o botão simplesmente não aparece.
     `ctx` vira atributo da conversa no Chatwoot: o atendente lê arma, uso, lanterna e red
     dot na barra lateral em vez de garimpar no texto. */
  Configurador.prototype.atendimentoAttrs = function (classe, msgWa, ctx, origem) {
    if (this.canal === 'chat') {
      return {
        'class': classe,
        href: this.chatContato,
        'data-abrir-chat': '',
        'data-chat-origem': origem || null,
        'data-chat-ctx': JSON.stringify(ctx || {})
      };
    }
    var href = this.waLink(msgWa);
    if (!href) return null;
    return { 'class': classe, href: href, target: '_blank', rel: 'noopener' };
  };

  /* mesma informação da mensagem de encomenda, em pares nome/valor para o chat */
  Configurador.prototype.ctxEncomenda = function () {
    var s = this.state;
    var ctx = { Origem: 'Configurador (sob encomenda)' };
    var arma = [s.fabricante, s.modelos.join(' + ')].filter(Boolean).join(' ');
    if (arma) ctx.Arma = arma;
    if (s.uso) ctx.Uso = s.uso.rotulo;
    var lant = this.lanternaDesc();
    if (lant) ctx.Lanterna = lant;
    else if (s.temLanterna === false) ctx.Lanterna = 'não';
    var aDefinir = this.L.redDotADefinir || 'a definir';
    ctx['Mão'] = s.mao || aDefinir;
    if (s.reddot === true) ctx['Red dot'] = 'sim';
    else if (s.reddot === false) ctx['Red dot'] = 'não';
    else if (this.aceitaRedDot()) ctx['Red dot'] = aDefinir;
    ctx.Cor = s.cor || aDefinir;
    return ctx;
  };

  Configurador.prototype.irPara = function (tela) {
    this._prevTela = this.state.tela;
    this.state.tela = tela;
    this._travado = false;
    this.render();
  };

  /* avança para a PRÓXIMA tela da sequência (recalculada após a resposta) */
  Configurador.prototype.avancarDe = function (tela) {
    var seq = this.sequencia();
    var i = seq.indexOf(tela);
    this.irPara((i >= 0 && i + 1 < seq.length) ? seq[i + 1] : 'resultado');
  };

  /* volta uma tela, limpando as respostas à frente */
  Configurador.prototype.voltar = function () {
    var seq = this.sequencia();
    var i = seq.indexOf(this.state.tela);
    var alvo = i > 0 ? seq[i - 1] : 'fab';
    this.limparApos(alvo);
    this.irPara(alvo);
  };

  /* trilha: pula direto para uma tela já respondida (limpa as à frente) */
  Configurador.prototype.voltarPara = function (tela) {
    // editar o uso que veio de um card: destrava o passo (vira escolha manual velado/
    // ostensivo) e solta a trava de lanterna do card "Com lanterna"
    if (tela === 'uso' && this._usoPre) { this._usoPre = null; this._lanternaPre = false; }
    this.limparApos(tela);
    this.irPara(tela);
  };

  /* seleção com pausa visível: marca, espera, avança */
  Configurador.prototype.selecionaEAvanca = function (btn, fn, telaAtual) {
    if (this._travado) return;
    this._travado = true;
    btn.classList.add('is-sel');
    var self = this;
    setTimeout(function () { fn(); self.avancarDe(telaAtual); }, DELAY_SELECAO);
  };

  Configurador.prototype.render = function () {
    this.setProgress();
    var t = this.state.tela;
    // "Voltar" do rodapé some no 1º passo (fabricante) e reaparece nos demais.
    if (this.btnVoltar) this.btnVoltar.hidden = (t === 'fab');
    var dir = ORDEM_TELA.indexOf(t) >= ORDEM_TELA.indexOf(this._prevTela) ? 'fwd' : 'back';
    this.stage.classList.remove('cfg-slide-fwd', 'cfg-slide-back');
    void this.stage.offsetWidth; // reinicia a animação
    this.stage.innerHTML = '';
    this.stage.classList.add('cfg-slide-' + dir);
    if (t === 'fab') this.renderFabricantes();
    else if (t === 'modelo') this.renderModelos();
    else if (t === 'uso') this.renderUso();
    else if (t === 'porte') this.renderPorte();
    else if (t === 'lanterna') this.renderLanternaPergunta();
    else if (t === 'lantMarca') this.renderLanternaFab();
    else if (t === 'lantModelo') this.renderLanternaModelo();
    else if (t === 'mao') this.renderMao();
    else this.renderResultado();
    // ao trocar de tela, volta o topo do funil (o cabeçalho sticky segue visível)
    if (this._jaRendeu) {
      if (this.overlayScroll) this.overlayScroll.scrollTop = 0;
      else if (this.root.scrollIntoView) { try { this.root.scrollIntoView({ block: 'start' }); } catch (e) {} }
    }
    this._jaRendeu = true;
  };

  /* Uso já escolhido no card da home (Cobra, 2026-09-28): a lista de marcas mostra PRIMEIRO
     as que têm pronta entrega naquele uso. Ele buscou porta-carregador da Bodyguard 2.0 e a
     Smith & Wesson "não apareceu": a lista seguia a ordem do editor, mostrava 6 marcas e
     escondia o resto em "Todas as marcas" — e entre as 6 visíveis estavam Beretta, IWI e
     Imbel, que NÃO têm porta-carregador, enquanto Smith & Wesson, Ruger e Colt, que têm,
     ficavam escondidas. A ordem do editor é preservada DENTRO de cada grupo, e a marca sem
     estoque continua na lista, porque ela leva à encomenda. Produto `universal` não conta
     (serve em todas as marcas e empataria tudo). No card "Com lanterna" só conta coldre
     com lanterna. O casamento marca → tag é o MESMO do matchEstoque. */
  Configurador.prototype.ordenaFabsPorEstoque = function (fabs) {
    if (!this._usoPre || !this._prodsFab || !this._prodsFab.length) return fabs;
    var usoTags = this.tagsDoUso(this._usoPre);
    var ehPc = usoTags.indexOf('portacarregador') !== -1;
    var lant = this._lanternaPre;
    var prods = this._prodsFab.filter(function (p) {
      var tem = function (t) { return p.tags.indexOf(t) !== -1; };
      if (!usoTags.every(tem)) return false;
      if (!ehPc && tem('portacarregador')) return false;
      if (lant && !tem('lanterna')) return false;
      return !tem('universal');
    });
    var com = [], sem = [];
    fabs.forEach(function (f) {
      var cands = [norm(f.nome), norm((f.nome || '').split(/[\s&]+/)[0])].filter(Boolean);
      var temEstoque = prods.some(function (p) {
        return cands.some(function (c) { return p.tags.indexOf(c) !== -1; });
      });
      (temEstoque ? com : sem).push(f);
    });
    return com.concat(sem);
  };

  /* Passo 1 — Fabricante: LISTA estilo app (mockup 4, 2026-07-05) — monograma/logo,
     nome e amostra dos modelos populares; 6 primeiras + linha "Todas as marcas" */
  Configurador.prototype.renderFabricantes = function () {
    var self = this;
    var VISIVEIS = 6;
    this.setSub(this.L.passoFab || 'Escolha o fabricante da sua arma');
    // no fluxo "com lanterna", esconde fabricantes que só têm revólver (ficariam sem modelo)
    var fabs = this._lanternaPre
      ? this.fabricantes.filter(function (f) { return self.modelosDoFab(f).length > 0; })
      : this.fabricantes;
    // uso já escolhido no card da home: marcas COM pronta entrega naquele uso vêm primeiro.
    // O índice chega por fetch; quando chegar, a lista é redesenhada já na ordem certa.
    if (this._usoPre && !this._prodsFab) {
      this.ensureIndex().then(function (prods) {
        self._prodsFab = prods || [];
        if (self.state.tela === 'fab') { self.stage.innerHTML = ''; self.renderFabricantes(); }
      });
    }
    fabs = this.ordenaFabsPorEstoque(fabs);
    if (!fabs.length) {
      this.stage.appendChild(el('p', { 'class': 'cfg-nota', text: 'Cadastre os fabricantes no editor (seção Configurador → blocos de Fabricante).' }));
      return;
    }
    var lista = el('div', { 'class': 'cfg-fablista' });
    fabs.forEach(function (fab, i) {
      var fonte = fab.populares.length ? fab.populares : fab.modelos;
      var amostra = fonte.slice(0, 4).join(' · ');
      if (fonte.length > 4) amostra += '…';
      var kids = [];
      if (fab.img) kids.push(el('img', { 'class': 'cfg-fabrow__img', src: fab.img, alt: '', loading: 'lazy' }));
      else kids.push(el('span', { 'class': 'cfg-fabrow__mono', 'aria-hidden': 'true', text: fab.nome.charAt(0).toUpperCase() }));
      kids.push(el('span', { 'class': 'cfg-fabrow__info' }, [
        el('span', { 'class': 'cfg-fabrow__nome', text: fab.nome }),
        amostra ? el('small', { 'class': 'cfg-fabrow__amostra', text: amostra }) : null
      ]));
      kids.push(el('span', { 'class': 'cfg-fabrow__chev', 'aria-hidden': 'true', text: '›' }));
      var row = el('button', { type: 'button', 'class': 'cfg-fabrow' }, kids);
      if (i >= VISIVEIS) { row.classList.add('cfg-fabrow--extra'); row.hidden = true; }
      row.addEventListener('click', function () {
        self.selecionaEAvanca(row, function () {
          self.state.fabricante = fab.nome;
          self.limparApos('fab'); // troca de marca zera modelo/uso/lanterna/red dot
        }, 'fab');
      });
      lista.appendChild(row);
    });
    if (fabs.length > VISIVEIS) {
      var mais = el('button', { type: 'button', 'class': 'cfg-fabrow cfg-fabrow--mais' }, [
        el('span', { 'class': 'cfg-fabrow__mono', 'aria-hidden': 'true', text: '+' }),
        el('span', { 'class': 'cfg-fabrow__info' }, [
          el('span', { 'class': 'cfg-fabrow__nome', text: this.L.todasMarcas || 'Todas as marcas' }),
          el('small', { 'class': 'cfg-fabrow__amostra', text: fabs.length + ' fabricantes' })
        ]),
        el('span', { 'class': 'cfg-fabrow__chev', 'aria-hidden': 'true', text: '⌄' })
      ]);
      mais.addEventListener('click', function () {
        Array.prototype.forEach.call(lista.querySelectorAll('.cfg-fabrow--extra'), function (r) { r.hidden = false; });
        mais.parentNode.removeChild(mais);
      });
      lista.appendChild(mais);
    }
    this.stage.appendChild(lista);

    var attrsMarca = this.atendimentoAttrs('cfg-link', null, { Origem: 'Configurador (marca não encontrada)' }, 'modelo');
    if (attrsMarca) {
      attrsMarca.text = this.L.semModelo || 'Não achou sua marca? Fale com a gente ↗';
      this.stage.appendChild(el('a', attrsMarca));
    }
  };

  /* Passo 2 — Modelo (adaptativo, 2026-07-07): busca no topo + chips arredondados.
     Marca GRANDE (>= LIMIAR modelos) mostra dois andares rotulados "Mais procurados"
     / "Todos os modelos"; marca com POUCOS modelos vira NUVEM ÚNICA sem rótulo (os
     populares vêm na frente, em oliva) — o rótulo pra meia dúzia de chips pesava. */
  Configurador.prototype.renderModelos = function () {
    var self = this;
    var fab = this.fabricantes.filter(function (f) { return f.nome === self.state.fabricante; })[0];
    this.setSub((this.L.passoModelo || 'Escolha o(s) modelo(s)') + ' — ' + this.state.fabricante);

    var modelos = this.modelosDoFab(fab);
    var pops = (fab && fab.populares) ? fab.populares : [];
    // populares na ordem do block (só os que existem na lista de modelos); resto = todos
    var popList = [], popSet = {};
    pops.forEach(function (p) {
      var match = modelos.filter(function (m) { return norm(m) === norm(p); })[0];
      if (match && !popSet[norm(match)]) { popList.push(match); popSet[norm(match)] = true; }
    });
    var restList = modelos.filter(function (m) { return !popSet[norm(m)]; });

    var busca = el('input', {
      type: 'search', 'class': 'cfg-busca', autocomplete: 'off',
      placeholder: this.L.buscaModelo || 'Toque ou digite o modelo (ex.: 19, 43x)',
      'aria-label': this.L.buscaModelo || 'Buscar modelo'
    });
    this.stage.appendChild(busca);

    var btns = [];
    function fazBtn(modelo, classe) {
      var pressed = self.state.modelos.indexOf(modelo) !== -1;
      var b = el('button', { type: 'button', 'class': classe, 'aria-pressed': pressed ? 'true' : 'false', text: modelo });
      b.setAttribute('data-norm', norm(modelo));
      b.addEventListener('click', function () {
        self.selecionaEAvanca(b, function () {
          self.state.modelos = [modelo];
          self.limparApos('modelo');            // zera uso/lanterna/red dot à frente
          self.state.uso = self._usoPre || null; // card já traz o uso
        }, 'modelo');
      });
      btns.push(b);
      return b;
    }

    var secoes = []; // {wrap, grade} — p/ esconder o andar vazio na busca
    function andar(rotulo, itens, gradeCls, btnCls) {
      if (!itens.length) return;
      var grade = el('div', { 'class': gradeCls });
      itens.forEach(function (m) { grade.appendChild(fazBtn(m, btnCls)); });
      var lbl = el('div', { 'class': 'cfg-modelos-rotulo', text: rotulo });
      var wrap = el('div', { 'class': 'cfg-modelos-secao' }, [lbl, grade]);
      self.stage.appendChild(wrap);
      secoes.push({ wrap: wrap, grade: grade, rotulo: lbl });
    }
    var LIMIAR_ANDARES = 16; // acima disso o "mais procurados" vira atalho útil
    if (popList.length && modelos.length >= LIMIAR_ANDARES) {
      // marca grande: dois andares rotulados
      andar(this.L.maisProcurados || 'Mais procurados', popList, 'cfg-modelos-grade', 'cfg-modelo cfg-modelo--pop');
      andar(this.L.todosModelos || 'Todos os modelos', restList, 'cfg-modelos-grade', 'cfg-modelo');
    } else {
      // marca pequena (ou sem populares): NUVEM ÚNICA — populares em oliva na frente,
      // resto na sequência, sem rótulo de seção
      var grade = el('div', { 'class': 'cfg-modelos-grade' });
      popList.forEach(function (m) { grade.appendChild(fazBtn(m, 'cfg-modelo cfg-modelo--pop')); });
      restList.forEach(function (m) { grade.appendChild(fazBtn(m, 'cfg-modelo')); });
      var wrap = el('div', { 'class': 'cfg-modelos-secao' }, [grade]);
      this.stage.appendChild(wrap);
      secoes.push({ wrap: wrap, grade: grade, rotulo: null });
    }

    var semRes = el('div', { 'class': 'cfg-sem-resultado' });
    var attrsModelo = this.atendimentoAttrs('cfg-link', null, { Origem: 'Configurador (modelo não encontrado)' }, 'modelo');
    if (attrsModelo) {
      attrsModelo.text = this.L.semResultado || this.L.semModelo || 'Não achou seu modelo? Fale com a gente ↗';
    }
    semRes.appendChild(attrsModelo
      ? el('a', attrsModelo)
      : el('p', { 'class': 'cfg-nota', text: 'Nenhum modelo encontrado.' }));
    semRes.style.display = 'none';
    this.stage.appendChild(semRes);

    busca.addEventListener('input', function () {
      var q = norm(busca.value), visTotal = 0;
      btns.forEach(function (b) {
        var ok = !q || b.getAttribute('data-norm').indexOf(q) !== -1;
        b.style.display = ok ? '' : 'none'; if (ok) visTotal++;
      });
      // esconde o andar (e o rótulo) que ficou sem nenhum visível
      secoes.forEach(function (s) {
        var algum = Array.prototype.some.call(s.grade.children, function (c) { return c.style.display !== 'none'; });
        s.wrap.style.display = algum ? '' : 'none';
        // durante a busca o rótulo "Mais procurados" atrapalha — some com filtro ativo
        if (s.rotulo) s.rotulo.style.display = q ? 'none' : '';
      });
      semRes.style.display = visTotal === 0 ? '' : 'none';
    });

    // "Voltar" fica no rodapé fixo do overlay (data-cfg-voltar) — sempre visível.
  };

  /* helper: dois botões grandes (sim/não, com/sem) que avançam sozinhos */
  Configurador.prototype.renderEscolhaBinaria = function (titulo, apoio, tela, opcoes) {
    var self = this;
    this.setSub(titulo);
    var wrap = el('div', { 'class': 'cfg-options cfg-options--uso cfg-options--bin' });
    opcoes.forEach(function (o) {
      var pressed = o.pressed;
      var pill = el('button', { type: 'button', 'class': 'cfg-pill cfg-pill--uso', 'aria-pressed': pressed ? 'true' : 'false', text: o.rotulo });
      pill.addEventListener('click', function () {
        self.selecionaEAvanca(pill, function () { o.set(); }, tela);
      });
      wrap.appendChild(pill);
    });
    var kids = [wrap];
    if (apoio) kids.push(el('p', { 'class': 'cfg-apoio-bin', text: apoio }));
    this.stage.appendChild(el('div', { 'class': 'cfg-field' }, kids));
    // "Voltar" fica no rodapé fixo do overlay (data-cfg-voltar) — sempre visível.
  };

  /* Cintura × perna — a única tela do funil em que uma das opções NÃO avança.
     "Na perna" é um beco: não fabricamos. Em vez de tela morta, o aviso aparece no mesmo
     passo e "Na cintura" continua ao alcance de um toque — o cliente entende e segue, em
     vez de sair do funil. Por isso o clique em "Na perna" atualiza o DOM na mão, sem
     `render()`: um re-render redispararia a animação de troca de passo, e não houve troca. */
  Configurador.prototype.renderPorte = function () {
    var self = this, s = this.state;
    this.setSub(this.L.portePergunta || 'Onde você vai usar o coldre?');

    var aviso = el('p', { 'class': 'cfg-aviso-porte', role: 'status', tabindex: '-1',
      text: this.L.porteRecusa ||
        'Não fabricamos mais coldre de perna nem com tira de perna. Os nossos coldres externos prendem na cintura, com passadores de cinto.' });
    aviso.hidden = (s.porte !== 'perna');

    var wrap = el('div', { 'class': 'cfg-options cfg-options--uso cfg-options--bin' });
    var bCin = el('button', { type: 'button', 'class': 'cfg-pill cfg-pill--uso',
      'aria-pressed': s.porte === 'cintura' ? 'true' : 'false',
      text: this.L.porteCintura || 'Na cintura' });
    bCin.addEventListener('click', function () {
      self.selecionaEAvanca(bCin, function () {
        s.porte = 'cintura'; self.limparApos('porte');
      }, 'porte');
    });
    var bPer = el('button', { type: 'button', 'class': 'cfg-pill cfg-pill--uso',
      'aria-pressed': s.porte === 'perna' ? 'true' : 'false',
      text: this.L.portePerna || 'Na perna' });
    bPer.addEventListener('click', function () {
      if (self._travado) return;              // não briga com o delay de "Na cintura"
      s.porte = 'perna';
      self.limparApos('porte');
      bPer.setAttribute('aria-pressed', 'true');
      bCin.setAttribute('aria-pressed', 'false');
      aviso.hidden = false;
      try { aviso.focus(); } catch (e) {}     // leitor de tela anuncia (role=status)
    });
    wrap.appendChild(bCin);
    wrap.appendChild(bPer);

    var kids = [wrap];
    if (this.L.porteApoio) kids.push(el('p', { 'class': 'cfg-apoio-bin', text: this.L.porteApoio }));
    kids.push(aviso);
    this.stage.appendChild(el('div', { 'class': 'cfg-field' }, kids));
    // "Voltar" fica no rodapé fixo do overlay (data-cfg-voltar) — sempre visível.
  };

  /* Lanterna — pergunta sim/não (fluxo geral; o card "Com lanterna" pula esta tela) */
  Configurador.prototype.renderLanternaPergunta = function () {
    var self = this, s = this.state;
    this.renderEscolhaBinaria(
      this.L.passoLanternaPergunta || 'Vai usar lanterna?',
      this.L.lanternaApoio || 'Coldre moldado para a arma com a lanterna acoplada.',
      'lanterna',
      [
        { rotulo: this.L.lanternaSim || 'Sim, tenho lanterna', pressed: s.temLanterna === true,
          set: function () { s.temLanterna = true; self.limparApos('lanterna'); } },
        { rotulo: this.L.lanternaNao || 'Não', pressed: s.temLanterna === false,
          set: function () { s.temLanterna = false; self.limparApos('lanterna'); } }
      ]
    );
  };

  /* Mao dominante — passo do funil desde 2026-08-26 (antes so existia dentro do card
     sob encomenda). Vem depois da lanterna e antes do resultado porque e ela que decide
     a ROTA: o catalogo tem canhoto sem percurso de corte, e prometer pronta entrega
     nesses casos e vender o que a fabrica nao corta. As opcoes saem do mesmo setting do
     card de encomenda (maos_lista), entao o nome que o cliente ve e um so. */
  Configurador.prototype.renderMao = function () {
    var self = this, s = this.state;
    var maos = this.maos.length ? this.maos : ['Destro', 'Canhoto'];
    this.renderEscolhaBinaria(
      this.L.passoMao || 'Qual é a sua mão dominante?',
      this.L.maoApoio || 'O coldre é moldado espelhado para canhoto.',
      'mao',
      maos.map(function (m) {
        return {
          rotulo: m, pressed: s.mao === m,
          set: function () { s.mao = m; self.limparApos('mao'); }
        };
      })
    );
  };

  /* Lanterna — MARCA (pills do setting + "outra"); espelha o fluxo da arma */
  Configurador.prototype.renderLanternaFab = function () {
    var self = this;
    this.setSub(this.L.passoLanterna || 'Qual é a marca da sua lanterna?');

    var wrap = el('div', { 'class': 'cfg-options cfg-options--uso' });
    this.lanternas.forEach(function (grupo) {
      var pressed = self.state.lanternaFab === grupo.fab;
      var pill = el('button', { type: 'button', 'class': 'cfg-pill cfg-pill--uso', 'aria-pressed': pressed ? 'true' : 'false', text: grupo.fab });
      pill.addEventListener('click', function () {
        self.selecionaEAvanca(pill, function () { self.state.lanternaFab = grupo.fab; self.limparApos('lantMarca'); }, 'lantMarca');
      });
      wrap.appendChild(pill);
    });
    // "outra marca": cai no campo livre da tela seguinte ('*' = marca fora da lista)
    var outra = el('button', { type: 'button', 'class': 'cfg-pill cfg-pill--uso', 'aria-pressed': 'false', text: this.L.lanternaOutraMarca || 'Outra / não está na lista' });
    outra.addEventListener('click', function () {
      self.selecionaEAvanca(outra, function () { self.state.lanternaFab = '*'; self.limparApos('lantMarca'); }, 'lantMarca');
    });
    wrap.appendChild(outra);
    this.stage.appendChild(el('div', { 'class': 'cfg-field' }, [wrap]));

    // "Voltar" fica no rodapé fixo do overlay (data-cfg-voltar) — sempre visível.
  };

  /* Lanterna — MODELO (pills da marca + campo livre) */
  Configurador.prototype.renderLanternaModelo = function () {
    var self = this;
    var fabSel = this.state.lanternaFab;
    var outraMarca = fabSel === '*';
    var grupo = this.lanternas.filter(function (g) { return g.fab === fabSel; })[0];
    var titulo = outraMarca
      ? (this.L.passoLanterna || 'Qual é a sua lanterna?')
      : (this.L.passoLanternaModelo || 'Qual é o modelo?') + ' — ' + fabSel;
    this.setSub(titulo);

    if (!outraMarca && grupo && grupo.modelos.length) {
      var wrap = el('div', { 'class': 'cfg-options cfg-options--uso' });
      grupo.modelos.forEach(function (modelo) {
        var completo = fabSel + ' ' + modelo;
        var pressed = self.state.lanterna && norm(self.state.lanterna) === norm(completo);
        var pill = el('button', { type: 'button', 'class': 'cfg-pill cfg-pill--uso', 'aria-pressed': pressed ? 'true' : 'false', text: modelo });
        pill.addEventListener('click', function () {
          self.selecionaEAvanca(pill, function () { self.state.lanterna = completo; self.limparApos('lantModelo'); }, 'lantModelo');
        });
        wrap.appendChild(pill);
      });
      this.stage.appendChild(el('div', { 'class': 'cfg-field' }, [wrap]));
    }

    // campo livre: outro modelo (marca conhecida) ou marca+modelo (outra marca)
    var ph = outraMarca
      ? (this.L.lanternaOutraLivre || 'Digite marca e modelo da lanterna')
      : (this.L.lanternaOutra || 'Outro — digite o modelo');
    var input = el('input', {
      type: 'search', 'class': 'cfg-busca cfg-lanterna-input', autocomplete: 'off',
      placeholder: ph, 'aria-label': ph
    });
    var ok = el('button', { type: 'button', 'class': 'button cfg-lanterna-ok', text: this.L.continuar || 'Continuar' });
    ok.addEventListener('click', function () {
      var txt = input.value.trim();
      if (!txt) self.state.lanterna = null; // sem modelo: encomenda "a definir"
      else if (!outraMarca && norm(txt).indexOf(norm(fabSel)) === -1) self.state.lanterna = fabSel + ' ' + txt;
      else self.state.lanterna = txt;
      self.limparApos('lantModelo');
      self.avancarDe('lantModelo');
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); ok.click(); }
    });
    this.stage.appendChild(el('div', { 'class': 'cfg-lanterna-outra' }, [input, ok]));

    // "Voltar" fica no rodapé fixo do overlay (data-cfg-voltar) — sempre visível.
  };

  /* Red Dot removido do funil (2026-07-07): consolidado na PDP. renderRedDot excluído;
     matchEstoque mantém a lógica defensiva (state.reddot fica null → variante sem RD). */

  /* Tipo de Uso (seleção avança sozinha, com a pausa) */
  Configurador.prototype.renderUso = function () {
    var self = this;
    this.setSub(this.L.passoUso || 'Tipo de Uso');

    var usoWrap = el('div', { 'class': 'cfg-options cfg-options--uso' });
    this.usos.forEach(function (uso) {
      var pressed = self.state.uso && self.state.uso.rotulo === uso.rotulo;
      var pill = el('button', { type: 'button', 'class': 'cfg-pill cfg-pill--uso', 'aria-pressed': pressed ? 'true' : 'false', text: uso.rotulo });
      pill.addEventListener('click', function () {
        self.selecionaEAvanca(pill, function () {
          self.state.uso = uso;
          self.limparApos('uso'); // troca de uso zera lanterna/red dot
        }, 'uso');
      });
      usoWrap.appendChild(pill);
    });
    this.stage.appendChild(el('div', { 'class': 'cfg-field' }, [usoWrap]));

    // "Voltar" fica no rodapé fixo do overlay (data-cfg-voltar) — sempre visível.
  };

  /* ---- Resultado: roteamento estoque × encomenda ---- */

  Configurador.prototype.tagsDoUso = function (uso) {
    var t = parseList(uso.tags || '').map(norm).filter(Boolean);
    if (t.length) return t;
    var r = norm(uso.rotulo);
    if (r.indexOf('porta') !== -1) return ['portacarregador'];
    var tags = [];
    if (r.indexOf('ostensivo') !== -1) tags.push('ostensivo');
    else if (r.indexOf('velado') !== -1) tags.push('velado');
    if (r.indexOf('mini') !== -1) tags.push('mini');
    return tags;
  };

  /* candidatos por marca/modelo tolerantes (G25 ~ g25/25/glock-25/glock-g25) */
  Configurador.prototype.matchEstoque = function (prods) {
    var s = this.state;
    var fab = norm(s.fabricante);
    var fabCands = [fab, norm((s.fabricante || '').split(/[\s&]+/)[0])]
      .filter(function (x, i, a) { return x && a.indexOf(x) === i; });
    var modeloCands = s.modelos.map(function (m) {
      var n = norm(m), c = [n];
      if (/^g\d/.test(n)) c.push(n.slice(1));
      fabCands.forEach(function (f) {
        c.push(f + n);
        if (/^g\d/.test(n)) c.push(f + n.slice(1));
      });
      return c;
    });
    var usoTags = this.tagsDoUso(s.uso);
    var ehMini = usoTags.indexOf('mini') !== -1;
    var ehPc = usoTags.indexOf('portacarregador') !== -1;
    var out = [];
    prods.forEach(function (p) {
      var tem = function (t) { return p.tags.indexOf(t) !== -1; };
      if (!usoTags.every(tem)) return;
      // PORTA-CARREGADOR continua EXCLUIDO fora do seu uso: nao e coldre, e outro item.
      if (!ehPc && tem('portacarregador')) return;
      // MINI nao: ate 2026-08-27 havia aqui um `if (!ehMini && tem('mini')) return;`, e
      // como a secao no ar so tem TRES usos (Velado, Ostensivo, Porta-carregador) e
      // nenhum "Mini", a linha mini ficava INALCANCAVEL pelo funil. O cliente pedia um
      // ostensivo pronta entrega para a G19 e caia em "sob encomenda" com o mini panqueca
      // em estoque. Mini nao e outro produto: e o mesmo uso num tamanho menor. Agora
      // aparece, mas por ULTIMO (ver ordena), para nao passar na frente do coldre padrao.
      if (fab && !fabCands.some(tem) && !tem('universal')) return;
      if (modeloCands.length && !modeloCands.some(function (c) { return c.some(tem); }) && !tem('universal')) return;
      // variante de vitrine: a MÃO escolhida no funil (2026-08-26; antes era sempre
      // destro) · Preto · e o Red Dot ESCOLHIDO no funil (com/sem) — assim o anúncio já
      // abre na variante certa (?variant=). Sem escolha = destro e sem RD.
      var querRd = s.reddot === true, escolheuRd = s.reddot === true || s.reddot === false;
      var maoAlvo = norm(s.mao || '') || 'destro';
      var melhor = null, melhorPeso = -1;
      for (var i = 0; i < p.variants.length; i++) {
        var vv = p.variants[i], peso = 0;
        if (p.iMao < 0 || norm(opt(vv, p.iMao)) === maoAlvo) peso += 4;
        if (p.iCor < 0 || norm(opt(vv, p.iCor)) === 'preto') peso += 2;
        if (p.iRd < 0) peso += 1; // produto sem eixo de red dot
        else {
          var rdCom = norm(opt(vv, p.iRd)) === 'com';
          if (escolheuRd ? (rdCom === querRd) : !rdCom) peso += 1;
        }
        if (peso > melhorPeso) { melhorPeso = peso; melhor = vv; }
      }
      if (melhor) out.push({ p: p, v: melhor, lanterna: tem('lanterna'), mini: tem('mini') });
    });
    // Lanterna respondida no funil: SIM → só coldres com lanterna (e, se nomeada, os
    // que a citam no título); NÃO → só coldres SEM lanterna. (vazio => cai na encomenda)
    /* o mini fecha a lista: aparece, mas depois do coldre padrão daquele uso */
    var ordena = function (lista) {
      return lista.sort(function (a, b) { return (a.mini ? 1 : 0) - (b.mini ? 1 : 0); });
    };
    if (this.temLanternaEfetivo()) {
      var lantSel = norm(this.state.lanterna || '');
      return ordena(out.filter(function (m) {
        return m.lanterna && (!lantSel || norm(m.p.titulo).indexOf(lantSel) !== -1);
      }));
    }
    if (s.temLanterna === false) {
      return ordena(out.filter(function (m) { return !m.lanterna; }));
    }
    // sem pergunta de lanterna (uso sem acessório): produtos sem lanterna primeiro
    out.sort(function (a, b) { return (a.lanterna ? 1 : 0) - (b.lanterna ? 1 : 0); });
    return ordena(out);
  };

  Configurador.prototype.precoEl = function (valor) {
    var wrap = el('div', { 'class': 'cfg-prod__preco' });
    if (this.pix.on && this.pix.pct > 0) {
      var pix = valor * (1 - this.pix.pct / 100);
      wrap.appendChild(el('s', { 'class': 'cfg-prod__cheio', text: fmtPreco(valor) }));
      wrap.appendChild(el('strong', { 'class': 'cfg-prod__pix', text: fmtPreco(pix) }));
      wrap.appendChild(el('span', { 'class': 'cfg-prod__pixlabel', text: this.pix.label }));
    } else {
      wrap.appendChild(el('strong', { 'class': 'cfg-prod__pix', text: fmtPreco(valor) }));
    }
    return wrap;
  };

  /* descrição da lanterna p/ resumo/WhatsApp/carrinho (ou null se não tem) */
  Configurador.prototype.lanternaDesc = function () {
    if (!this.temLanternaEfetivo()) return null;
    return this.state.lanterna || (this.L.lanternaADefinir || 'com lanterna (modelo a definir)');
  };

  /* mensagem de encomenda aglutinando arma + uso + lanterna + red dot, em linhas
     (mais legível pro atendimento). \n vira quebra de linha no WhatsApp. */
  Configurador.prototype.waMsgConfig = function () {
    var s = this.state;
    var arma = [s.fabricante, s.modelos.join(' + ')].filter(Boolean).join(' ');
    var lant = this.lanternaDesc();
    var linhas = [this.L.waEnc || 'Olá! Quero um coldre sob encomenda:'];
    if (arma) linhas.push('• Arma: ' + arma);
    if (s.uso) linhas.push('• Uso: ' + s.uso.rotulo);
    if (lant) linhas.push('• Lanterna: ' + lant);
    else if (s.temLanterna === false) linhas.push('• Lanterna: não');
    var aDefinir = this.L.redDotADefinir || 'a definir';
    linhas.push('• Mão: ' + (s.mao || aDefinir));
    if (s.reddot === true) linhas.push('• Red dot: sim');
    else if (s.reddot === false) linhas.push('• Red dot: não');
    // não respondido num uso que aceita óptica: o atendimento precisa saber que falta
    else if (this.aceitaRedDot()) linhas.push('• Red dot: ' + aDefinir);
    linhas.push('• Cor: ' + (s.cor || aDefinir));
    return linhas.join('\n');
  };

  Configurador.prototype.addCarrinho = function (variantId, props, btn) {
    var self = this;
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: props || {} })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = '/cart';
    }).catch(function () {
      btn.disabled = false; btn.textContent = original;
      var erro = el('p', { 'class': 'cfg-nota', text: self.L.erroAdd || 'Não foi possível adicionar. Tente de novo.' });
      btn.parentNode.appendChild(erro);
      setTimeout(function () { if (erro.parentNode) erro.parentNode.removeChild(erro); }, 4000);
    });
  };

  Configurador.prototype.cardProduto = function (cfg) {
    var kids = [];
    kids.push(el('span', { 'class': 'cfg-prod__selo cfg-prod__selo--' + cfg.tipo, text: cfg.selo }));
    if (cfg.img) {
      var img = el('img', { 'class': 'cfg-prod__img', src: cfg.img, alt: cfg.titulo || '', loading: 'lazy' });
      var inner = cfg.url
        ? el('a', { 'class': 'cfg-prod__imglink', href: cfg.url, 'aria-label': cfg.titulo || 'Ver produto' }, [img])
        : img;
      // foto-padrão ilustrativa: mesmo selo da PDP (detecta pelo nome do arquivo no CDN)
      if (/ilustrativ/i.test(cfg.img)) {
        var selo = el('span', { 'class': 'cfg-prod__ilustrativa', text: this.L.seloIlustrativa || 'Imagem ilustrativa' });
        kids.push(el('div', { 'class': 'cfg-prod__imgwrap' }, [inner, selo]));
      } else {
        kids.push(inner);
      }
    }
    kids.push(el('p', { 'class': 'cfg-prod__titulo', text: cfg.titulo }));
    if (cfg.sub) kids.push(el('p', { 'class': 'cfg-prod__sub', text: cfg.sub }));
    if (cfg.preco != null) kids.push(this.precoEl(cfg.preco));
    if (cfg.notaPreco) kids.push(el('p', { 'class': 'cfg-prod__sub', text: cfg.notaPreco }));
    // bloco opcional entre o texto e os botões (sob encomenda: a escolha do red dot)
    if (cfg.extra) kids.push(cfg.extra);
    // acoesEl: container de botões VIVO — o chamador remonta o CTA quando a escolha muda
    kids.push(cfg.acoesEl || el('div', { 'class': 'cfg-prod__acoes' }, cfg.botoes || []));
    return el('article', { 'class': 'cfg-prod' }, kids);
  };

  /* Resumo da configuração. Redesenhável: a escolha do red dot no card sob encomenda
     tem que refletir aqui em cima na hora. */
  Configurador.prototype.preencheResumo = function (resumo) {
    var s = this.state;
    var linhas = [
      ['Fabricante', s.fabricante],
      ['Modelo(s)', s.modelos.join(', ')],
      [this.L.tipoUso || 'Tipo de uso', s.uso ? s.uso.rotulo : '']
    ];
    var lantDesc = this.lanternaDesc();
    if (lantDesc) linhas.push([this.L.progLanterna || 'Lanterna', lantDesc]);
    else if (s.temLanterna === false) linhas.push([this.L.progLanterna || 'Lanterna', this.L.semLanterna || 'Sem lanterna']);
    if (s.mao) linhas.push([this.L.encMao || 'Mão', s.mao]);
    if (s.reddot === true) linhas.push([this.L.progRedDot || 'Red dot', this.L.redDotSim || 'Com red dot']);
    else if (s.reddot === false) linhas.push([this.L.progRedDot || 'Red dot', this.L.redDotNao || 'Sem red dot']);
    if (s.cor) linhas.push([this.L.encCor || 'Cor', s.cor]);
    resumo.innerHTML = '';
    linhas.forEach(function (par) {
      resumo.appendChild(el('div', { 'class': 'cfg-resumo__linha' }, [
        el('span', { 'class': 'cfg-resumo__chave', text: par[0] }),
        el('span', { 'class': 'cfg-resumo__valor', text: par[1] || '—' })
      ]));
    });
  };

  /* amostra de cor: reusa os tons do Kydex da PDP (cobra-variantes-overlay.css). Casa por
     texto para o nome continuar editável ("Preto", "Preto Tático"…) sem perder a cor. */
  function classeSwatch(valor) {
    var n = norm(valor), chaves = ['preto', 'coiote', 'oliva', 'carbono'];
    for (var i = 0; i < chaves.length; i++) {
      if (n.indexOf(chaves[i]) !== -1) return 'cfg-enc-sw--' + chaves[i];
    }
    return 'cfg-enc-sw--generico';
  }

  /* Um grupo de escolha do card sob encomenda: rótulo + botões + nota opcional.
     tipo 'seg'   = dois botões largos (mão, red dot), igual ao segmentado da PDP.
     tipo 'cores' = chips com amostra do Kydex.
     cfg.valores = [{ label, valor }] — `valor` é o que entra no estado (string ou boolean). */
  Configurador.prototype.grupoEnc = function (cfg) {
    var ehCor = cfg.tipo === 'cores';
    var grupo = el('div', { 'class': ehCor ? 'cfg-enc-cores' : 'cfg-enc-seg',
      role: 'group', 'aria-label': cfg.titulo });
    var botoes = [];
    cfg.valores.forEach(function (v) {
      var kids = [];
      if (ehCor) kids.push(el('span', { 'class': 'cfg-enc-cor__sw ' + classeSwatch(v.valor), 'aria-hidden': 'true' }));
      kids.push(el('span', { text: v.label }));
      var b = el('button', {
        type: 'button', 'class': ehCor ? 'cfg-enc-cor' : 'cfg-enc-seg__btn',
        'aria-pressed': cfg.atual() === v.valor ? 'true' : 'false'
      }, kids);
      b.addEventListener('click', function () {
        cfg.set(v.valor);
        botoes.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (cfg.aoMudar) cfg.aoMudar();
      });
      botoes.push(b);
      grupo.appendChild(b);
    });
    var kids = [el('p', { 'class': 'cfg-enc-opc__rotulo', text: cfg.titulo }), grupo];
    if (cfg.nota) kids.push(el('p', { 'class': 'cfg-enc-opc__apoio', text: cfg.nota }));
    return el('div', { 'class': 'cfg-enc-grupo' }, kids);
  };

  /* Opções que, COM estoque, o cliente escolheria na PDP — e que sob encomenda não tinham
     onde ser escolhidas, porque não existe página de produto: MÃO, RED DOT e COR.
     Ordem igual à da PDP (mão, red dot, cor). Mão e cor valem para tudo que se fabrica;
     só o red dot sai fora do revólver e dos usos sem acessório (mini, porta-carregador),
     do mesmo jeito que a PDP faz.
     A cor leva a NOTA DE CUSTO (Cobra, 2026-08-19): cor diferente do preto custa mais e o
     carbono é o mais alto. Sem valor em reais no card: o preço da encomenda fecha no
     atendimento, e prometer um delta sobre uma base indefinida seria promessa no escuro.
     Sem aviso de garantia vitalícia aqui de propósito: encomenda ainda não é produto, então
     não há metafield custom.garantia_vitalicia para conferir antes de citar (bug de 03/08). */
  Configurador.prototype.opcoesEncomenda = function (aoMudar) {
    var s = this.state, blocos = [];

    // MÃO saiu daqui em 2026-08-26: virou passo do funil (renderMao), e reperguntar no
    // card seria pedir duas vezes a mesma coisa. Ela segue no resumo e na mensagem do
    // atendimento; para trocar, o chip do resumo volta ao passo.

    if (this.aceitaRedDot()) {
      blocos.push(this.grupoEnc({
        titulo: this.L.passoRedDot || 'Vai usar red dot?', tipo: 'seg', aoMudar: aoMudar,
        nota: this.L.redDotApoio,
        valores: [
          { label: this.L.redDotSim || 'Com red dot', valor: true },
          { label: this.L.redDotNao || 'Sem red dot', valor: false }
        ],
        atual: function () { return s.reddot; },
        set: function (v) { s.reddot = v; }
      }));
    }

    if (this.cores.length) {
      blocos.push(this.grupoEnc({
        titulo: this.L.encCor || 'Cor do Kydex', tipo: 'cores', aoMudar: aoMudar,
        nota: this.L.encCorNota,
        valores: this.cores.map(function (c) { return { label: c, valor: c }; }),
        atual: function () { return s.cor; },
        set: function (v) { s.cor = v; }
      }));
    }

    if (!blocos.length) return null;
    return el('div', { 'class': 'cfg-enc-opc' }, blocos);
  };

  Configurador.prototype.renderResultado = function () {
    var self = this;
    var s = this.state;
    this.setSub('Seu coldre');

    var resumo = el('div', { 'class': 'cfg-resumo' });
    this.preencheResumo(resumo);
    this.stage.appendChild(resumo);

    var area = el('div', { 'class': 'cfg-resultado' });
    area.appendChild(el('p', { 'class': 'cfg-nota', text: this.L.verificando || 'Verificando estoque…' }));
    this.stage.appendChild(area);

    var reinicia = el('button', { type: 'button', 'class': 'cfg-back', text: this.L.recomecar || 'Recomeçar' });
    reinicia.addEventListener('click', function () {
      self._usoPre = null; // recomeçar zera também o que veio do card da home
      self._lanternaPre = false;
      self.state = { tela: 'fab', fabricante: null, modelos: [], uso: null, porte: null,
                     temLanterna: null, lanternaFab: null, lanterna: null, reddot: null,
                     mao: null, cor: null };
      self._prevTela = 'resultado';
      self.render();
    });
    this.stage.appendChild(el('div', { 'class': 'cfg-actions' }, [reinicia]));

    // arma escolhida vai na URL: a PDP personaliza o titulo (cobra-arma-titulo.js)
    var armaQ = s.fabricante && s.modelos.length
      ? '&arma=' + encodeURIComponent(s.fabricante + ' ' + s.modelos[0])
      : '';

    this.ensureIndex().then(function (prods) {
      var achados = self.matchEstoque(prods);
      if (achados.length) {
        area.innerHTML = '';
        var grid = el('div', { 'class': 'cfg-prods' });
        achados.slice(0, 8).forEach(function (m) {
          var ver = el('a', {
            'class': 'button cfg-prod__btn', text: self.L.verOpcoes || 'Ver opções e comprar',
            href: '/products/' + m.p.handle + '?variant=' + m.v.id + armaQ
          });
          grid.appendChild(self.cardProduto({
            tipo: 'pronta',
            selo: self.L.pronta || 'Pronta entrega',
            // foto da VARIANTE de vitrine (Destro·Preto·sem RD) — a capa do produto
            // pode ser outra cor (fotos subiram em ordem alfabética: carbono 1º)
            img: (m.v.featured_image && m.v.featured_image.src) || m.p.img,
            url: '/products/' + m.p.handle + '?variant=' + m.v.id + armaQ,
            titulo: m.p.titulo,
            preco: parseFloat(m.v.price) || 0,
            botoes: [ver]
          }));
        });
        area.appendChild(grid);
        return;
      }
      // sem estoque -> SOB ENCOMENDA: atendimento pelo canal vigente (chat do site desde
      // 2026-08-19) com os dados aglutinados (arma + uso + lanterna + red dot). A compra sob
      // encomenda (preço da matriz de Metaobjects) fica p/ a Fase 2 (ver MATRIZ-PRECOS.md).
      area.innerHTML = '';
      var sub = [s.fabricante, s.modelos.join(', ')].filter(Boolean).join(' · ');
      // O CTA carrega a configuração DENTRO dele (mensagem do WhatsApp / contexto do chat),
      // então é remontado a cada mudança de opção. Um <a> montado uma vez só levaria o dado
      // velho — foi exatamente o bug do botão de WhatsApp da PDP (2026-08-19).
      var acoes = el('div', { 'class': 'cfg-prod__acoes' });
      var montaCta = function () {
        acoes.innerHTML = '';
        var attrsEnc = self.atendimentoAttrs('cfg-prod__wa', self.waMsgConfig(), self.ctxEncomenda(), 'encomenda');
        if (!attrsEnc) return;
        // CTA PRINCIPAL da encomenda: aqui não há botão "Comprar" âmbar dividindo o palco,
        // então o atendimento leva o peso de ação principal. Ícone + rótulo (linha 1) e
        // microcopy de apoio (linha 2). A cor sai do CSS, por canal.
        var encMicro = self.L.waMicro || 'Fechamos o pedido com você, preço e prazo';
        var icone = el('span', { 'class': 'cfg-prod__wa-ico', html: self.canal === 'chat' ? CHAT_SVG : WA_SVG });
        var l1 = el('span', { 'class': 'cfg-prod__wa-l1' }, [icone, el('span', { text: self.L.waBtn || 'Encomendar pelo chat' })]);
        var kids = [l1];
        if (encMicro) kids.push(el('span', { 'class': 'cfg-prod__wa-l2', text: encMicro }));
        if (self.canal === 'chat') attrsEnc['class'] = 'cfg-prod__wa cfg-prod__wa--chat';
        acoes.appendChild(el('a', attrsEnc, kids));
      };
      montaCta();
      // sem PDP, o red dot é escolhido AQUI; mudou, o resumo e o CTA acompanham na hora
      var opcoes = self.opcoesEncomenda(function () {
        self.preencheResumo(resumo);
        montaCta();
      });
      area.appendChild(self.cardProduto({
        tipo: 'enc',
        selo: self.L.encomenda || 'Sob encomenda · prazo no atendimento',
        titulo: self.L.encTitulo || 'Fabricamos para você',
        sub: sub,
        notaPreco: self.L.precoBreve || 'Fechamos o pedido pelo chat, com o preço e o prazo.',
        extra: opcoes,
        acoesEl: acoes
      }));
    });
  };

  function init() {
    document.querySelectorAll('[data-configurador]').forEach(function (root) {
      if (root.__cfgInit) return;
      root.__cfgInit = true;
      new Configurador(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
